<ng-container *ngIf="model?.length===0 && !isCustom">
  <span>-</span>
</ng-container>

<ng-container *ngIf="model?.length===1">
  <span>{{model[0]}}</span>
</ng-container>

<ng-container *ngIf="model?.length>1">

  <button mat-icon-button [popoverTitle]="title|translate" [autoClose]="'outside'" [ngbPopover]="listItem"
    [placement]="placement">
    <i class="tw-text-sm" [class]="fontClass"></i>
  </button>


  <ng-template #listItem>
    <ul class="tw-dir-rtl ltr:tw-dir-ltr">
      <li *ngFor="let item of model">{{item}}</li>
    </ul>
  </ng-template>


</ng-container>


<!-- custom  -->
<ng-container *ngIf="isCustom">

  <button mat-icon-button [popoverTitle]="title|translate" [autoClose]="'outside'" [ngbPopover]="items"
    [placement]="placement">
    <i class="tw-text-sm" [class]="fontClass"></i>
  </button>

  <ng-template #items>
      <ng-content select=".custom"></ng-content>
  </ng-template>

</ng-container>
